<template>
  <i class="level_6" title="6级"></i>
</template>

<script>
    export default {
        name: "Level_6"
    }
</script>

<style scoped>
    .level_6 {
      background-image: url(/static/img/icons_2.png);
      display: inline-block;
      width: 21px;
      height: 14px;
      background-position: -38px -349px;
      vertical-align: middle;
      cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/icon/level/Level_6.vue